module.exports = __webpack_public_path__ + "static/img/img12.0523705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img12.png
// module id = /ouc
// module chunks = 1